module.exports = __webpack_public_path__ + "img/green-cash.b6d3ce7f.svg";